import styled from "styled-components";

const Logo = styled.img`
  max-width: 100%;
  height: auto;
`;
export default Logo;